module.exports = __webpack_public_path__ + "static/media/RemoteMissionInactive.b3e7fb72.svg";